//noinspection JSFileReferences
import index from './search/index.js';

index.init();